<template>
  <div >
    <VivaLoader/>
    <div class="home relative flex flex-col">
      <Header customClass="border-b-2 border-gray-100"/>
      <main class="home-component mx-auto mt-16 w-full">
        <div class="bg-blue-100 text-white relative py-10">
          <div class="max-w-6xl flex flex-col md:flex-row justify-between items-center mx-auto px-4 ">
            <div class="w-full md:w-8/12 sm:text-center lg:text-left px-20 xs:px-5 mini:px-2">
              <h1 class="text-4xl tracking-tight font-semibold text-white md:text-5xl">
                <span class="block xl:inline">Viva Fan</span>
              </h1>
              <h2 class="text-2xl tracking-tight font-medium text-white md:text-2xl mb-10 mt-3">
                {{bannerTranslate[language].title }}
              </h2>
              <div class="mt-5 sm:mt-5 sm:flex sm:justify-center lg:justify-start">
                <div class="rounded-md shadow">
                  <button @click.prevent="goToDashboard()" v-if="(isLoggedIn && subscription) || !isLoggedIn" class=" w-full flex items-center justify-center px-12 py-3 text-base font-bold rounded-md text-white bg-none border-2 border-white hover:bg-white hover:text-blue-100 md:py-4 md:text-lg md:px-20 "> 
                    {{bannerTranslate[language].buttonLogin }}
                   </button>
                </div>
              </div>
            </div>
            <div class="w-full pb-16 md:pb-0 md:w-4/12 flex content-center align-center justify-center md:justify-start">
              <img class="xs:w-60 w-48 h-auto xs:mt-10" src="../assets/img/landing/personaje.png" alt="">
            </div>
          </div>
        </div>
        <section class="bg-white px-3 pt-10 sm:px10 md:px-20">
          <div class="max-w-4xl mx-auto px-4 py-6 sm:py-6 md:py-6 lg:pt-6 lg:pb-6">
            <div class="text-center sm:text-center lg:text-center">
              <div class="p-2 w-full flex align-center justify-center content-center">
                 <img class="xs:w-80 w-4/6 h-auto" src="https://content.vivaaerobus.com/pwa/beneficios/VivaFan.svg" :alt="'prueba'" />
              </div>
              <h2 class="section-header text-2xl sm:text-3xl text-green-400 font-bold mb-0 sm:mb-4">{{ maintenanceTranslate[language].title }}</h2>
              <p class="xs:mt-2">{{ maintenanceTranslate[language].content[0] }}</p>
              <p class="xs:mt-2">{{ maintenanceTranslate[language].content[1] }}</p>
              <div class="max-w-xs px-4 py-10 m-auto">
               <a :href="languageToDoters" class="subscribe_btn">
                {{ maintenanceTranslate[language].button }}
               </a>
            </div>
            </div>
          </div>
        </section>
        <section class="bg-white pt-10">
          <div class="max-w-4xl mx-auto px-4 py-6 sm:py-6 md:py-6 lg:pt-6 lg:pb-6">
            <div class="text-center sm:text-left lg:text-left mb-10">
              <h2 class="section-header text-2xl sm:text-3xl text-green-300 font-bold mb-2">{{faqTranslate[language].title}}</h2>
            </div>

            <FAQ
            v-for="(faq, i) in faqs"
            :index="i"
            :key="i"
            :title="faq.title"
            :open="faq.open"
            @toggleOpen="toggleOpen">

              <div  v-if="typeof faq.content === 'function'">
                  <div v-html="faq.content(faqPrices)"> </div>
              </div>
              <div v-html="faq.content" v-else></div>

            </FAQ>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import Header from "@/components/header/Header.vue"
import Footer from "@/components/Footer.vue"
import FAQ from "@/components/Accordion.vue"
import VivaLoader from "@/components/loader/Loader.vue"
import { computed, onMounted, ref } from "vue"
import { useRouter } from 'vue-router'
import { bannerTranslate } from '@/translations/Banner.js'
import { benefitsTranslate } from '@/translations/Benefits.js'
import { pricingTranslate } from '@/translations/Pricing.js'
import { faqTranslate } from '@/translations/FAQ.js'
import { reviewsTranslate } from '@/translations/Reviews.js'
import { maintenanceTranslate } from '@/translations/Maintenance.js'
import { dataLayerExpandQandA,dataLayerBeginCheckout } from  '@/pixels/datalayer.js'
import { canPurchase } from "../api/environment";
import { environment } from '@/api/environment.js'


export default {
  name: "Home",
  components: {
    Header,
    Footer,
    FAQ,
    VivaLoader
  },

  setup() {
    const _canPurchase = canPurchase;
    const store  = useStore()
    const router = useRouter()
    const faqPrices = ref({
        team :  {
            price : 0,
            regularPrice: 0
        },
         solo :  {
            price : 0,
            regularPrice: 0
        },
    })
  
    const isLoggedIn = computed(() => {
        return store.getters.isLoggedin
    })

    const isLoadingPackage = computed( ()=> { 
            return store.state.Plans.loading
        })

    const subscription =  computed( () => {
      return store.state.Checkout.data.userSubscription.data
    })

    const errorPlans = computed(() => {
      return store.state.Plans.error
    })

    const plan = computed(() => {
        return store.state.Plans.data.plans.find( ({subscriptionType}) =>  subscriptionType == 'Single')
    })

    const language = computed( ()=> {
      return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
    })

    const languageToDoters = computed( ()=> {
      return environment.GO_TO_DOTERS[language.value].link;
    })


    const currency = computed(() => {
      return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
    })


    const getPlans = async ( auth ) => {
      const currencyParameter = ( currency.value == 'MXN' ? `?currency=${currency.value}` : `?currency=${currency.value}`)
      let params =  { currency: currencyParameter, useAuthToken : false , continue : false }

    if( Object.keys(store.state.Accounts.data ).length == 0 ){
         if( isLoggedIn.value ){
            params.continue  = true
         }
      }

    if ( auth ){
        params.useAuthToken =  true
    }

    params.retain = '&retain=true'

      await store.dispatch('getPlans', params ) 
    }

    const goToDashboard = () => {
      if( !isLoggedIn.value ){
        window.location.href = `https://www.vivaaerobus.com/es-mx/?loginType=vivafan&showLogin=true&loginRedirect=true&redirectUrl=${window.location.href.replace(/\/$/, "")}`;
        return;
      }

      router.push({ name : 'DashboardSubscription' })
    }

    const setTranslate = () => {
        const lang= language.value == 'es' ?  'eng' : 'es'
        localStorage.setItem('viva-user-token-expires',lang )

    }

    const onSubmit = ( plan ) =>{
          dataLayerBeginCheckout( plan )
          if( isLoggedIn.value ){
              store.commit( 'SELECT_PLAN', plan )
               router.push( { name : 'Profile'} )
          } else {
              window.location.href = `https://www.vivaaerobus.com/es-mx/?loginType=vivafan&showLogin=true&loginRedirect=true&redirectUrl=${window.location.href.replace(/\/$/, "")}`
          }
    }
    
    const faqs = ref([
        ...faqTranslate[language.value].content,
      ])

    const generatePrices = async () => {
      let plans = store.state.Plans.data.plans
      if( plans ){
        let team = plans.find( ({subscriptionType}) => { return subscriptionType == 'Team' || subscriptionType == 'Team Anual' })
        let solo = plans.find( ({subscriptionType}) => { return subscriptionType == 'Single'})
          
        let prices =  {
          currency: currency.value
        }

        if( team ){
          prices.team = {
              price : team.netTotalAmount,
              regularPrice: (team.planAmount * parseFloat( `1.${team.taxPercentage}`)).toFixed(0)
          }
        }

        if( solo ) {
          prices.solo = {
              price : solo.netTotalAmount,
              regularPrice: (solo.planAmount * parseFloat( `1.${solo.taxPercentage}`)).toFixed(0)
          }
        }

        faqPrices.value = prices
      }
    }

    onMounted( async () => {
      if( isLoggedIn.value ){
         if( !subscription.value ){
           let params = { plan: 'vfn' , continue : true} 
           if( Object.keys(store.state.Accounts.data).length == 0 ){
             params.continue  = true
           }
          await store.dispatch('getSubscription', params )
          await getPlans( true )
        }
        if( Object.keys(store.state.Accounts.data).length == 0 ){
          await store.dispatch('checkAccount', {noLoading: false})
        }
        generatePrices()

      } else {
        await getPlans()
        generatePrices()
      }
    })

    return {errorPlans, isLoggedIn, plan, isLoadingPackage, subscription, bannerTranslate, benefitsTranslate, pricingTranslate, reviewsTranslate, faqTranslate, maintenanceTranslate, faqPrices, faqs, language, _canPurchase, onSubmit, goToDashboard, languageToDoters,  setTranslate}
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    toggleOpen: function (index) {
      this.faqs = this.faqs.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open
          dataLayerExpandQandA( faq.title )
        } else {
          faq.open = false
        }
        return faq;
      });
    }
  }
}
</script>

<style scoped>
.subscribe_btn {
  @apply w-full flex bg-blue-100 items-center justify-center px-12 py-3 text-base font-bold rounded-xl text-white bg-none border-2 border-white hover:bg-blue-200 hover:text-white md:py-4 md:text-lg 
}

</style>